import Router from './router';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
